module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av155-7accad6ddac7035519ee3a395d2ee5f7.jpg";